
/*!
 * @pendo/components 3.25.3
 * (c) 2018-present
 */

import 'lodash/isEqual';
import 'just-kebab-case';
import { P as PendoAnalytics } from './labels-mixin.js';
import { b as _objectWithoutProperties, _ as _objectSpread } from './_rollupPluginBabelHelpers-mixin.js';
import 'lodash/kebabCase';
import 'feather-icons';
import PendoIcon from './pendo-icon.js';
import 'v-tooltip';
import './tooltip-mixin.js';
import PendoTooltip from './pendo-tooltip.js';
import { e as emitter } from './emitter-mixin.js';
import Multiselect from 'vue-multiselect';
import Select from 'element-ui/lib/select';
import Option from 'element-ui/lib/option';

const SCROLL_BLOCK_CLASS = 'pendo-components--is-blocking-scroll';
var script = {
  name: 'PendoSelect',
  components: {
    ElSelect: Select,
    ElOption: Option,
    PendoIcon,
    Multiselect
  },
  directives: {
    PendoAnalytics,
    PendoTooltip
  },
  mixins: [emitter],
  props: {
    value: {
      type: [Object, String, Number],
      default: null
    },
    type: {
      type: String,
      default: 'multiselect'
    },
    options: {
      type: Array,
      required: true
    },
    theme: {
      type: String,
      default: 'dark'
    },
    selectProps: {
      type: Object,
      default: () => ({})
    },
    selectLabel: {
      type: String,
      default: null
    },
    selectLabelPosition: {
      type: String,
      default: 'top',
      validator: position => ['top', 'bottom', 'suffix'].includes(position)
    },
    selectLabels: {
      type: Object,
      default: () => ({})
    },
    allowEmpty: {
      type: Boolean,
      default: false
    },
    showLabels: {
      type: Boolean,
      default: false
    },
    maxHeight: {
      type: Number,
      default: 240
    },
    optionHeight: {
      type: Number,
      default: 28
    },
    groupValues: {
      type: String,
      default: null
    },
    groupLabel: {
      type: String,
      default: null
    },
    groupSelect: {
      type: Boolean,
      default: false
    },
    internalSearch: {
      type: Boolean,
      default: true
    },
    loading: {
      type: Boolean,
      default: false
    },
    trackBy: {
      type: String,
      default: null
    },
    label: {
      type: String,
      default: null
    },
    subLabel: {
      type: String,
      default: null
    },
    showNoResults: {
      type: Boolean,
      default: true
    },
    noResults: {
      type: String,
      default: 'No results found'
    },
    placeholder: {
      type: String,
      default: 'Select option'
    },
    preselectFirst: {
      type: Boolean,
      default: true
    },
    showNoResultsOverride: {
      type: Boolean,
      default: false
    },
    searchable: {
      type: Boolean,
      default: true
    },
    searchChange: {
      type: Function,
      default: null
    },
    editIconClass: {
      type: String,
      default: ''
    },
    copyIconClass: {
      type: String,
      default: ''
    },
    permalabel: {
      type: String,
      default: ''
    },
    invalid: {
      type: Boolean,
      default: false
    },
    dynamicSearchInputSize: {
      type: Boolean,
      default: false
    },
    appendToBody: {
      type: Boolean,
      default: false
    },
    triggerWidth: {
      type: [String, Number],
      default: null
    },
    prefixIcon: {
      type: String,
      default: null
    }
  },

  data() {
    return {
      model: this.value ? this.value : null,
      active: false,
      scrollParents: []
    };
  },

  computed: {
    selectListeners() {
      const _this$$listeners = this.$listeners,
            change = _this$$listeners.change,
            visibleChange = _this$$listeners.visibleChange,
            listeners = _objectWithoutProperties(_this$$listeners, ["change", "visibleChange"]);

      return _objectSpread({}, listeners, {
        ['change']: this.onChange,
        ['visible-change']: this.onVisibilityChange
      });
    },

    getMultiSelectProps() {
      const _this$_props = this._props,
            options = _this$_props.options,
            value = _this$_props.value,
            noResults = _this$_props.noResults,
            showNoResultsOverride = _this$_props.showNoResultsOverride,
            defaultProps = _objectWithoutProperties(_this$_props, ["options", "value", "noResults", "showNoResultsOverride"]);

      return Object.assign({}, defaultProps, this.$attrs);
    },

    selectPopperClass() {
      let popperClass = `el-select-dropdown--${this.theme}`;

      if (this.selectProps.popperClass) {
        popperClass += this.selectProps.popperClass;
      }

      if (this.invalid) {
        popperClass += ' is-invalid';
      }

      if (this.active) {
        popperClass += ' is-active';
      }

      return popperClass;
    },

    topLabel() {
      if (this.selectLabel && ['top', 'left'].includes(this.selectLabelPosition)) {
        return this.selectLabel;
      }

      return this.selectLabels.top || this.selectLabels.left;
    },

    bottomLabel() {
      if (this.selectLabel && ['bottom', 'right'].includes(this.selectLabelPosition)) {
        return this.selectLabel;
      }

      return this.selectLabels.bottom || this.selectLabels.right;
    },

    inlineLabel() {
      return ['left', 'right'].includes(this.labelPosition) || this.selectLabels.left || this.selectLabels.right;
    },

    dropdownTriggerWidth() {
      if (typeof this.triggerWidth === 'string') {
        return this.triggerWidth;
      }

      return `${this.triggerWidth}px`;
    },

    analyticsTagFromLabels() {
      const tag = [];

      if (this.topLabel) {
        tag.push(this.topLabel);
      }

      if (this.bottomLabel) {
        tag.push(this.bottomLabel);
      }

      if (this.inlineLabel) {
        tag.push(this.inlineLabel);
      }

      return tag.join(' ');
    }

  },
  watch: {
    value(value) {
      this.model = value;
    }

  },
  methods: {
    getMultiSelectOptionLabel(option) {
      const label = option.$groupLabel || option[this.label] || option.text;
      const imageWithoutText = this.label === 'img' && !option.text;

      if (label === 'divider' || label === 'default' || imageWithoutText) {
        return '';
      }

      return label;
    },

    getMultiSelectOptionClass(option) {
      return {
        'multiselect__divider-label': option[this.label] === 'divider' || option.$groupLabel === 'divider',
        'multiselect__group-label': option.$groupLabel ? option.$groupLabel !== 'divider' : false,
        'multiselect__option-label': option[this.label] ? option[this.label] !== 'divider' : false
      };
    },

    getScrollParents(node) {
      const parents = [];

      for (; node && node !== document; node = node.parentNode) {
        const isElement = node instanceof HTMLElement;
        const overflowY = isElement && window.getComputedStyle(node).overflowY;
        const isScrollable = overflowY !== 'visible' && overflowY !== 'hidden';

        if (isScrollable) {
          parents.push(node);
        }
      }

      return parents;
    },

    onVisibilityChange(visible) {
      if (visible) {
        this.onOpen();
      } else {
        this.onClose();
        this.$refs.pendoSelect.blur();
      }

      this.$emit('visibleChange', visible);
    },

    onChange(value) {
      if (this.selectProps.emitObject) {
        const valueKey = this.selectProps.valueKey || 'value';
        const match = this.options.find(option => option[valueKey] === value);
        this.$emit('change', match);
        return;
      }

      this.$emit('change', value);

      if (this.type === 'multiselect') {
        this.updateValue(value);
      }
    },

    emitOptionMouseEnter(option) {
      this.$emit('option-mouseenter', option);
    },

    emitOptionMouseLeave(option) {
      this.$emit('option-mouseleave', option);
    },

    onSearch(searchQuery) {
      this.$emit('searchChange', searchQuery);
    },

    onOpen() {
      this.$emit('onOpen', this);
      this.active = true;

      if (this.type === 'multiselect') {
        if (this.appendToBody) {
          this.applyAppendToBodyStyles();
        }

        if (this.searchable && this.dynamicSearchInputSize) {
          this.setMultiSelectSearchInputSize();
        }

        if (this.$slots.afterList) {
          this.setMultiSelectFooterPosition();
        }

        return;
      }
    },

    applyAppendToBodyStyles() {
      const pendoSelect = this.$refs.pendoSelect;
      pendoSelect.$refs.tags.style.pointerEvents = 'none';
      setTimeout(() => {
        pendoSelect.$refs.tags.style.pointerEvents = null;
      }, 300);
      this.scrollParents = this.getScrollParents(pendoSelect.$el);
      this.scrollParents.forEach(parent => {
        parent.classList.add(SCROLL_BLOCK_CLASS);
      });
      document.body.classList.add(SCROLL_BLOCK_CLASS);

      if (pendoSelect.isAbove) {
        const _pendoSelect$$el$getB = pendoSelect.$el.getBoundingClientRect(),
              top = _pendoSelect$$el$getB.top;

        const bottom = window.innerHeight - top;
        pendoSelect.$refs.list.style.bottom = `${bottom + 8}px`;
      } else {
        const _pendoSelect$$el$getB2 = pendoSelect.$el.getBoundingClientRect(),
              bottom = _pendoSelect$$el$getB2.bottom;

        pendoSelect.$refs.list.style.top = `${bottom}px`;
      }

      const triggerWidth = pendoSelect.$refs.tags.getBoundingClientRect().width;
      const windowWidth = window.innerWidth;
      const maxDropdownWidth = parseInt(getComputedStyle(pendoSelect.$refs.list).maxWidth, 10);
      pendoSelect.$refs.list.style.position = 'fixed';
      pendoSelect.$refs.list.style.zIndex = 2004;

      if (['100%', 'auto'].includes(this.triggerWidth)) {
        const maxWidth = Math.min(windowWidth, maxDropdownWidth, triggerWidth);
        pendoSelect.$refs.list.style.maxWidth = `${maxWidth}px`;
        pendoSelect.$refs.list.style.minWidth = `${maxWidth}px`;
      } else {
        pendoSelect.$refs.list.style.minWidth = `${triggerWidth}px`;
      }
    },

    resetAppendToBodyStyles() {
      const _this$$refs$pendoSele = this.$refs.pendoSelect.$refs,
            list = _this$$refs$pendoSele.list,
            tags = _this$$refs$pendoSele.tags;
      tags.style.pointerEvents = 'none';
      setTimeout(() => {
        list.style.position = null;
        list.style.bottom = null;
        list.style.top = null;
        list.style.zIndex = null;
        list.style.minWidth = null;
        list.style.maxWidth = null;
        tags.style.pointerEvents = null;
        this.scrollParents.forEach(parent => {
          parent.classList.remove(SCROLL_BLOCK_CLASS);
        });
        document.body.classList.remove(SCROLL_BLOCK_CLASS);
      }, 350);
    },

    onClose() {
      if (this.appendToBody) {
        this.resetAppendToBodyStyles();
      }

      this.$emit('onClose', this);
      this.active = false;
      this.dispatch('ElFormItem', 'el.form.blur', [this.model]);
    },

    onEdit(option) {
      this.$emit('onEdit', option);
    },

    onCopy(option) {
      this.$emit('onCopy', option);
    },

    setMultiSelectFooterPosition() {
      this.$nextTick(() => {
        const footer = this.$refs.afterList;
        const wrapper = this.$refs.pendoSelect.$refs.list;
        const content = this.$refs.pendoSelect.$el.querySelector('.multiselect__content');
        content.style.height = `${parseInt(wrapper.clientHeight, 10)}px`;
        wrapper.style.minWidth = `${parseInt(footer.scrollWidth, 10)}px`;
      });
    },

    setMultiSelectSearchInputSize({
      size = this.placeholder.length
    } = {}) {
      this.$refs.pendoSelect.$refs.search.setAttribute('size', Math.min(30, Math.max(10, size)));
    },

    updateValue(selected) {
      let match = false;

      if (this.groupValues) {
        this.options.forEach(option => {
          match = match || option[this.groupValues].includes(selected);
        });
      } else {
        match = this.options.includes(selected);
      }

      if (match) {
        this.model = selected;
        this.$emit('input', selected);
        this.$emit('onSelect', selected);
      }
    }

  }
};

const __vue_script__ = script;

var __vue_render__ = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "pendo-select",
    class: {
      'is-inline-label': !!_vm.inlineLabel
    }
  }, [!!_vm.topLabel || !!_vm.$slots.topLabel ? _c('div', {
    staticClass: "pendo-select__label pendo-select__label--top"
  }, [_vm._t("topLabel", [_vm._v("\n            " + _vm._s(_vm.topLabel) + "\n        ")])], 2) : _vm._e(), _vm._v(" "), _vm.type === 'select' ? _c('el-select', _vm._g(_vm._b({
    directives: [{
      name: "pendo-analytics",
      rawName: "v-pendo-analytics",
      value: {
        type: 'components:select',
        value: _vm.analyticsTagFromLabels
      },
      expression: "{ type: 'components:select', value: analyticsTagFromLabels }"
    }],
    ref: "pendoSelect",
    class: ["el-select--" + _vm.theme, {
      'is-invalid': _vm.invalid,
      'is-active': _vm.active
    }],
    style: {
      width: _vm.dropdownTriggerWidth
    },
    attrs: {
      "placeholder": _vm.placeholder,
      "popper-class": _vm.selectPopperClass
    },
    model: {
      value: _vm.model,
      callback: function ($$v) {
        _vm.model = $$v;
      },
      expression: "model"
    }
  }, 'el-select', _vm.selectProps, false), _vm.selectListeners), [_vm.$slots.prefix || _vm.$scopedSlots.prefix ? _c('div', {
    attrs: {
      "slot": "prefix"
    },
    slot: "prefix"
  }, [_vm._t("prefix")], 2) : _vm._e(), _vm._v(" "), _vm._l(_vm.options, function (option, index) {
    return _c('el-option', {
      directives: [{
        name: "pendo-analytics",
        rawName: "v-pendo-analytics",
        value: {
          type: 'components:select-option',
          value: option[_vm.selectProps.labelKey] || option.label || option
        },
        expression: "{\n                type: 'components:select-option',\n                value: option[selectProps.labelKey] || option.label || option\n            }"
      }],
      key: "pendo-select-dropdown__item-" + index,
      class: {
        'el-select-dropdown__item--divided': option.divided
      },
      attrs: {
        "label": option[_vm.selectProps.labelKey] || option.label || option,
        "value": option[_vm.selectProps.valueKey] || option.value || option
      }
    }, [_vm._t(option[_vm.selectProps.valueKey] || option.value, null, {
      "option": option
    })], 2);
  }), _vm._v(" "), _vm.$slots.footer || _vm.$scopedSlots.footer ? _c('li', {
    staticClass: "el-select-dropdown__item el-select-dropdown__footer el-select-dropdown__item--divided"
  }, [_vm._t("footer")], 2) : _vm._e()], 2) : _vm._e(), _vm._v(" "), _vm.type === 'multiselect' ? _c('multiselect', _vm._b({
    directives: [{
      name: "pendo-analytics",
      rawName: "v-pendo-analytics",
      value: {
        type: 'components:select',
        value: _vm.analyticsTagFromLabels
      },
      expression: "{ type: 'components:select', value: analyticsTagFromLabels }"
    }],
    ref: "pendoSelect",
    class: ["multiselect--" + _vm.theme, {
      'multiselect--searchable': _vm.searchable,
      'multiselect--empty': _vm.showNoResultsOverride,
      'multiselect--invalid': _vm.invalid,
      'multiselect--has-afterlist': _vm.$slots.afterList,
      'multiselect--has-footer': _vm.$slots.footer
    }],
    style: {
      'max-width': _vm.dropdownTriggerWidth,
      width: _vm.dropdownTriggerWidth
    },
    attrs: {
      "max-height": _vm.maxHeight,
      "option-height": _vm.optionHeight,
      "options": _vm.options,
      "placeholder": _vm.placeholder
    },
    on: {
      "open": _vm.onOpen,
      "close": _vm.onClose,
      "search-change": _vm.onSearch,
      "input": _vm.updateValue
    },
    scopedSlots: _vm._u([{
      key: "caret",
      fn: function (ref) {
        var toggle = ref.toggle;
        return _c('div', {
          staticClass: "multiselect__select",
          on: {
            "mousedown": function ($event) {
              $event.preventDefault();
              $event.stopPropagation();
              return toggle($event);
            }
          }
        }, [_c('pendo-icon', {
          attrs: {
            "type": "chevron-down",
            "size": "14"
          }
        })], 1);
      }
    }, {
      key: "singleLabel",
      fn: function (ref) {
        var _obj;

        var option = ref.option;
        return option[_vm.label] || option.img ? [_vm._t("selectedLabel", [_vm._t(option.img ? 'img' : 'icon', [option.img ? _c('img', {
          staticClass: "multiselect__option-img",
          style: {
            maxHeight: _vm.optionHeight + "px"
          },
          attrs: {
            "src": option.img
          }
        }) : _vm._e(), _vm._v(" "), typeof option.icon === 'string' ? _c('i', {
          class: (_obj = {
            'fa-icon': option.icon
          }, _obj["fa " + option.icon] = option.icon, _obj)
        }) : _vm._e(), _vm._v(" "), option.icon && option.icon.type ? _c('pendo-icon', _vm._b({}, 'pendo-icon', option.icon, false)) : _vm._e()], {
          "option": option
        }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.permalabel || option[_vm.label]))])])] : undefined;
      }
    }, {
      key: "option",
      fn: function (ref) {
        var option = ref.option;
        return option[_vm.label] || option.$isLabel || option.img ? [_c('div', {
          directives: [{
            name: "pendo-tooltip",
            rawName: "v-pendo-tooltip",
            value: {
              delay: {
                show: 500,
                hide: 0
              },
              content: option.tooltipContent,
              arrow: true,
              boundariesElement: 'viewport'
            },
            expression: "{ delay: { show: 500, hide: 0 }, content: option.tooltipContent, arrow: true, boundariesElement: 'viewport' }"
          }],
          staticClass: "multiselect__option-wrapper",
          on: {
            "mouseenter": function ($event) {
              return _vm.emitOptionMouseEnter(option);
            },
            "mouseleave": function ($event) {
              return _vm.emitOptionMouseLeave(option);
            }
          }
        }, [_vm._t(option.img ? 'img' : 'icon', [option.img ? _c('img', {
          staticClass: "multiselect__option-img",
          style: {
            maxHeight: _vm.optionHeight + "px"
          },
          attrs: {
            "src": option.img
          }
        }) : _vm._e(), _vm._v(" "), typeof option.icon === 'string' ? _c('i', {
          class: [{
            'fa fa-icon': option.icon
          }, option.icon]
        }) : _vm._e(), _vm._v(" "), option.icon && option.icon.type ? _c('pendo-icon', _vm._b({}, 'pendo-icon', option.icon, false)) : _vm._e()], {
          "option": option
        }), _vm._v(" "), _c('span', {
          directives: [{
            name: "pendo-analytics",
            rawName: "v-pendo-analytics",
            value: {
              type: 'components:select-option',
              value: _vm.getMultiSelectOptionLabel(option)
            },
            expression: "{\n                        type: 'components:select-option',\n                        value: getMultiSelectOptionLabel(option)\n                    }"
          }],
          class: _vm.getMultiSelectOptionClass(option)
        }, [_vm._t(option.slotName, [_vm._v("\n                        " + _vm._s(_vm.getMultiSelectOptionLabel(option)) + "\n                    ")])], 2), _vm._v(" "), option[_vm.subLabel] ? _c('span', {
          staticClass: "multiselect__option-sub-label"
        }, [_vm._v("\n                    " + _vm._s(option[_vm.subLabel]) + "\n                ")]) : _vm._e(), _vm._v(" "), option.$isEditable ? _c('pendo-icon', {
          class: _vm.editIconClass,
          attrs: {
            "tag": "span",
            "type": "edit",
            "size": "14"
          },
          on: {
            "click": function ($event) {
              $event.stopPropagation();
              return _vm.onEdit(option);
            }
          }
        }) : _vm._e(), _vm._v(" "), option.$isCopyable ? _c('pendo-icon', {
          class: _vm.copyIconClass,
          attrs: {
            "tag": "span",
            "type": "copy",
            "size": "14"
          },
          on: {
            "click": function ($event) {
              $event.stopPropagation();
              return _vm.onCopy(option);
            }
          }
        }) : _vm._e()], 2)] : undefined;
      }
    }], null, true),
    model: {
      value: _vm.model,
      callback: function ($$v) {
        _vm.model = $$v;
      },
      expression: "model"
    }
  }, 'multiselect', _vm.getMultiSelectProps, false), [_vm.$slots.prefix || _vm.$scopedSlots.prefix || !!_vm.prefixIcon ? _c('div', {
    staticClass: "multiselect__prefix",
    attrs: {
      "slot": "clear"
    },
    slot: "clear"
  }, [_vm._t("prefix", [_c('pendo-icon', {
    attrs: {
      "stroke": "#2a2c35",
      "size": 14,
      "type": _vm.prefixIcon
    }
  })])], 2) : _vm._e(), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _c('template', {
    slot: "noResult"
  }, [_vm._v("\n            " + _vm._s(_vm.noResults) + "\n        ")]), _vm._v(" "), _vm.$slots.afterList || _vm.$slots.footer ? _c('li', {
    ref: "afterList",
    class: {
      'multiselect__after-list': !!_vm.$slots.afterList,
      multiselect__footer: !!_vm.$slots.footer
    },
    attrs: {
      "slot": "afterList"
    },
    slot: "afterList"
  }, [_vm._t("afterList"), _vm._v(" "), _vm._t("footer")], 2) : _vm._e()], 2) : _vm._e(), _vm._v(" "), !!_vm.bottomLabel || !!_vm.$slots.bottomLabel ? _c('div', {
    staticClass: "pendo-select__label pendo-select__label--bottom"
  }, [_vm._t("bottomLabel", [_vm._v("\n            " + _vm._s(_vm.bottomLabel) + "\n        ")])], 2) : _vm._e()], 1);
};

var __vue_staticRenderFns__ = [];
const __vue_inject_styles__ = undefined;
const __vue_scope_id__ = undefined;
const __vue_is_functional_template__ = false;

function __vue_normalize__(template, style, script, scope, functional, moduleIdentifier, createInjector, createInjectorSSR) {
  const component = (typeof script === 'function' ? script.options : script) || {};
  component.__file = "pendo-select.vue";

  if (!component.render) {
    component.render = template.render;
    component.staticRenderFns = template.staticRenderFns;
    component._compiled = true;
    if (functional) component.functional = true;
  }

  component._scopeId = scope;

  return component;
}

var pendoSelect = __vue_normalize__({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__);

export default pendoSelect;
